// packages/utils/src/shared/i18n/languageTagLocale.ts
//
// The platform locale a language tag names, read the same way wherever a caller hands us a tag of its own: an
// `Accept-Language` entry (`acceptLanguageLocale.ts`) and an embed widget's `data-lang` attribute
// (`packages/storefront/src/utils/widgetLanguage.ts`).

import { canonicalizeLegacyLocale } from '@tourtask/i18n/config';
import type { AppLocale } from '@tourtask/types/i18n';

/**
 * The platform locale `tag` names, or `null` when it names none. The language is the primary subtag, in any case
 * (`sv-SE`, `zh-Hant-TW`, `sv_SE`, `SV` → `sv`, `zh`, `sv`, `sv`), a legacy code mapped the way stored site
 * languages are (`cmn` → `zh`, `canonicalizeLegacyLocale`). A three-letter code is never cut down to two letters:
 * `jam` (Jamaican Creole) is not `ja`, and `english` is not `en`.
 */
export function languageTagLocale(tag: string): AppLocale | null {
  const primarySubtag = tag.trim().split(/[-_]/)[0]?.toLowerCase() ?? '';
  return canonicalizeLegacyLocale(primarySubtag);
}
